import { extendTheme } from '@chakra-ui/react'

const theme = {
    colors: {
        core: {
            dg: "#171717",
            red: "#FF6B6B",
            white: "#FFFFFF",
            mg: "#2F2F2F",
            lg: "#606060"
        }
    },
    fonts: {
        primary: "Manrope, sans-serif",
        heading: "Manrope, sans-serif",
        body: "Manrope, sans-serif"
    },
    config: {
        useSystemColorMode: false,
    },
  }

export default extendTheme(theme);